import {Carousel, Image} from "antd";
import React from "react";
import './index.scss'

const HhxCarousel = ({images = [], onClick = f => f}) => {

    const handleClick = (url) => {
        if (url) {
            onClick(url)
        }
    }

    return (
        <Carousel autoplay style={{outline: 'none',width:'100%',minWidth:"1024px"}}>
            {
                images.map(image => (
                    <Image
                        width="100%"
                        key={image.id}
                        preview={false}
                        src={image.imgUrl}
                        onClick={() => handleClick(image.jumpUrl)}
                    />
                ))
            }
        </Carousel>
    )
}

export default HhxCarousel